// Vendor imports
const { connect } = require('react-redux')
const { createSelector } = require('reselect')
// Client V2 common imports
const { navigate } = require('client-v2/common/state/router/actions')
// Container imports
const AppNav = require('./component-dumb')

function mapStateToProps(state) {
  if (!state.user.loggedIn) {
    // Hide the nav bar for logged-out users
    return { hidden: true, items: [] }
  }
  // Determine selected state
  return {
    // Flags
    hidden: state.env.nativeEmbedded,
    // Values
    items: navItems(state),
    selected: selectedNavItemId(state)
  }
}

const mapDispatchToProps = {
  onNavigate: navigate
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  AppNav
)

// Helpers

const navItems = createSelector(
  state => state.user.getExperiment('*web_moods') !== 'disabled',
  isMoodsEnabled => {
    const navItems = []
    if (isMoodsEnabled) {
      navItems.push({
        id: 'moods',
        title: 'Moods',
        href: '/moods',
        aliases: [
          '/mood',
          '/discover'
        ]
      })
    }
    navItems.push({
      id: 'for-you',
      title: 'For you',
      href: '/for-you',
      aliases: [
        '/',
        '/add',
        '/mixit',
        '/top-for-you'
      ]
    })
    navItems.push({
      id: 'following',
      title: 'Following',
      href: '/following',
      aliases: [
        '/recently-added'
      ]
    })
    if (!isMoodsEnabled) {
      navItems.push({
        id: 'popular',
        title: 'Popular',
        href: '/popular',
        aliases: [
          '/mix',
          '/interests',
          '/collections',
          '/people',
          '/explore',
          '/explore/interests',
          '/explore/collections',
          '/explore/people'
        ]
      })
    }
    navItems.push({
      id: 'shared',
      title: 'Shared',
      href: '/shared',
      aliases: []
    })
    return navItems
  }
)

const selectedNavItemId = createSelector(
  [
    navItems,
    state => state.router.location.pathname
  ],
  (navItems, pathname) => {
    for (let item of navItems) {
      if (item.href === pathname || item.aliases.includes(pathname)) {
        return item.id
      }
    }
  }
)
